import moment from 'moment';

const convertIsoWeekdayForEnum = (number) => {
  switch (number) {
    case 1:
      return 'monday';
    case 2:
      return 'tuesday';
    case 3:
      return 'wednesday';
    case 4:
      return 'thursday';
    case 5:
      return 'friday';
    case 6:
      return 'saturday';
    case 7:
      return 'sunday';
    default:
      throw new Error('Not is IsoWeekday');
  }
};

const getDayOfWeek = (date) => {
  return convertIsoWeekdayForEnum(moment(date).isoWeekday());
};

export default getDayOfWeek;
